// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShiftSettings_wrapper__GaH3U","times":"ShiftSettings_times__NjQWK","timeSelector":"ShiftSettings_timeSelector__0eAad","button":"ShiftSettings_button__iNuXa"};